module.exports = __webpack_public_path__ + "front/img/i3.0205eecf.png";